<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <h3 class="m-v-0">
      {{is_create ? '创建新' : '编辑'}}任务
    </h3>
    <el-alert title="说明" type="warning" show-icon :closable="false" class="m-v-10">
      <ol class="el-alert__description">
        <li>创建后需要手动点击"启用"才会向教师开放。</li>
        <li>每位教师在提交时，只能上传一个文件。</li>
      </ol>
    </el-alert>
    <el-form :rules="rules" :model="form" ref="form" label-width="6em" label-position="left">
      <el-form-item label="所属部门" prop="department_uid">
        <el-select v-if="is_create" v-model="form.department_uid" class="full-width">
          <el-option v-for="department in departments" :key="department.uid"
                     :value="department.uid" :label="department.name"></el-option>
        </el-select>
        <span v-else>{{department_map[form.department_uid]}}</span>
      </el-form-item>
      <el-form-item label="任务名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入任务名称"></el-input>
      </el-form-item>
      <el-form-item label="具体要求" prop="desc">
        <el-input type="textarea" v-model="form.desc" :autosize="{minRows: 2}" placeholder="具体要求可不填"></el-input>
      </el-form-item>
      <el-form-item label="附件" prop="file">
        <select-file @change="selectFile">
          <el-button type="success" size="small">{{form.file ? '重新选择' : '选择文件'}}</el-button>
        </select-file>
        <template v-if="form.file">
          <icon :name="form.file.name | fileicon"></icon>
          {{form.file.name}}
        </template>
      </el-form-item>
      <div class="text-center m-v-10">
        <el-button type="success" size="cons" @click="submit()" :loading="submit_loading>0">
          {{is_create ? '创建' : '更新'}}
        </el-button>
        <el-button type="default" size="cons" @click="$router.back()" v-if="!$query.department_uid">取消
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy'
import mapValues from 'lodash/mapValues'

import * as Collection from 'api/collection'

export default {
  data () {
    return {
      form: null,
      department_map: null,
      ready: false,
      submit_loading: 0,
      rules: {
        departments: [this.$rules.required({message: '你没有选择部门，请返回重选', type: 'array'})],
        name: [this.$rules.required('任务名称必填')],
      },
    }
  },
  computed: {
    is_create () {
      return !this.$query.collection_uid
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [collection, departments] = await Promise.all([
          this.$query.collection_uid ? Collection.get({uid: this.$query.collection_uid}) : null,
          Collection.user_department_list({user_uid: this.$user.uid}),
        ])
        this.form = collection || {
          name: '',
          desc: '',
          department_uid: this.$query.department_uid,
          file: null,
          collection_type: 'plan',
        }
        this.department_map = mapValues(keyBy(departments, 'uid'), 'name')
        this.departments = departments
        this.ready = true
      })
    },
    selectFile (files) {
      this.form.file = files[0]
    },
    async submit () {
      if (!await this.$validate(this.$refs.form)) return
      this.$guard(this, 'submit_loading')(async () => {
        await Collection.edit(this.form)
        this.$message.success('保存成功')
        this.$router.replace(this.$location.admin_collection_list({department_uid: this.form.department_uid}, false))
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style lang="scss" scoped>
.el-alert {
  ol {
    padding-left: 1em;
    margin: 5px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collection/AdminCollectionEdit.vue